"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getChallengeRegisterParams = function getChallengeRegisterParams(_ref) {
  var challenge = _ref.challenge,
      user = _ref.user,
      _ref$restart = _ref.restart,
      restart = _ref$restart === void 0 ? false : _ref$restart,
      code = _ref.code,
      clientId = _ref.clientId;

  var userId = user._id.toString();

  var params = {
    challengeId: challenge._id,
    clientId: clientId,
    userId: userId,
    restart: restart
  };

  if (code) {
    params.code = code;
  }

  return params;
};

var _default = getChallengeRegisterParams;
exports["default"] = _default;
//# sourceMappingURL=getChallengeRegisterParams.js.map